module.exports = __webpack_public_path__ + "456ee25652cb081e18567658f61132c5.png";